module.exports = __webpack_public_path__ + "static/media/1040614300.724c5bb8.jpg";